import React from "react";

import personImg from "../../../assets/images/Dietplan-updated/bd1ae976ff3d22f2a76f3d9f4b809f7c7b1125e8.png";
import iconsStripImg from "../../../assets/images/Dietplan-updated/Group 1116601230.png";
import signatureImg from "../../../assets/images/Dietplan-updated/b53acf30a7d769be963a7e4f9ac480e826207672.png";
import bgVector from "../../../assets/images/Dietplan-updated/Vector (1).png";
import heroSilverImg from "../../../assets/images/Dietplan-updated/Plan Screen Image /05.webp";

import "./HeroStaticSilver.css";

const FEATURES = [
  {
    title: "Calorie tracking",
    desc: "Count every calorie—stay on track, no excuses!",
  },
  {
    title: "Report Insights",
    desc: "Unlock powerful insights—see your progress, own your success!",
  },
  {
    title: "Health Guardians",
    desc: "Your health. Your rules—stay guided, stay unbeatable!",
  },
  {
    title: "Water tracker",
    desc: "Hydrate like a pro—track it, sip it, crush it!",
  },
  {
    title: "Estimated HbA1C",
    desc: "Know your numbers—take charge, stay ahead of diabetes!",
  },
];

const HeroStaticSilver = () => {
  const SHOW_COMPOSED_HERO = false;

  return (
    <div className="diet-hero-silver-wrap" aria-label="Silver plan hero">
      <div className={`diet-hero-silver ${SHOW_COMPOSED_HERO ? "diet-hero-silver--composed" : "diet-hero-silver--svg"}`}>
        <div className="diet-hero-silver__bg" aria-hidden="true" />
        <div className="diet-hero-silver__rings" aria-hidden="true" />

        <img className="diet-hero-silver__vector" src={bgVector} alt="" aria-hidden="true" loading="lazy" />

        <img className="diet-hero-silver__person" src={personImg} alt="" loading="lazy" draggable="false" />

        <div className="diet-hero-silver__copy">
          <div className="diet-hero-silver__title">Track your daily health with smart insights</div>
          <div className="diet-hero-silver__sub">
            Track calories, hydration &amp; health insights to stay on top of your fitness goals.
          </div>
          <img
            className="diet-hero-silver__signature"
            src={signatureImg}
            alt="Rohit Sharma signature"
            loading="lazy"
          />
        </div>

        <img className="diet-hero-silver__heroImg" src={heroSilverImg} alt="" aria-hidden="true" loading="lazy" />
      </div>

      <div className="diet-hero-silver__cardWrap">
        <div className="diet-hero-silver__card">
          <div className="diet-hero-silver__cardTitle silver-plan-gradient-text">Pro Lite Plan</div>
          <img className="diet-hero-silver__icons" src={iconsStripImg} alt="" aria-hidden="true" loading="lazy" />

          <ul className="diet-hero-silver__list">
            {FEATURES.map((f) => (
              <li key={f.title} className="diet-hero-silver__item">
                <span className="diet-hero-silver__check" aria-hidden="true" />
                <div className="diet-hero-silver__itemText">
                  <div className="diet-hero-silver__itemTitle">{f.title}</div>
                  <div className="diet-hero-silver__itemDesc">{f.desc}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HeroStaticSilver;

